import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'unh-list-item',
  templateUrl: './list-item.component.html',
  styleUrls: ['./list-item.component.scss']
})
export class ListItemComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
